import { Back } from "client/src/components/Back/Back";
import { OverlappingCircles } from "client/src/components/Circle/OverlappingCircles";
import { StackY } from "client/src/components/Spacing/Spacing";
import { H1, H3 } from "client/src/components/Typography/Typography";

import * as styles from "./navigationHeader.module.css";

type NavigationHeaderProps = {
  backTo: string | null;
  hideBack?: boolean;
  pretitle?: string;
  title: string;
};

export const NavigationHeader = ({ backTo, hideBack, pretitle, title }: NavigationHeaderProps) => {
  return (
    <div className={styles.wrapper}>
      <OverlappingCircles side="right" className="mr-[128px]" />

      <StackY dist={8} className={styles.content}>
        {!hideBack && (
          <Back to={backTo} variant="yellow">
            Back
          </Back>
        )}

        {pretitle && (
          <H3 as="div" white>
            {pretitle}
          </H3>
        )}

        <H1 white>{title}</H1>
      </StackY>
    </div>
  );
};
